import { publishTopicOnChannel } from '../../services/external-pub-sub/pub-sub-utils';
import { eChannels, ePublishers, eTopics } from '../../utils/enums';
import { Actions } from './actions';

export function setLatestOutcomes(outcomes) {
  return (dispatch) => dispatch(Actions.setLatestOutcomes(outcomes));
}

export function setQueuedOutcome(outcome) {
  return (dispatch) => dispatch(Actions.setQueuedOutcome(outcome));
}

export function clearQueuedOutcomes() {
  return (dispatch) => dispatch(Actions.clearQueuedOutcomes());
}

export function clientInitSucceeded(calledFromMethod) {
  return (dispatch) => {
    publishTopicOnChannel(
      eTopics.session.clientInitSucceeded,
      eChannels.session,
      calledFromMethod,
      null,
      { publisher: ePublishers.sportclient }
    );
    dispatch(Actions.clientInitSucceeded());
  };
}
